import React, { useState, useEffect } from "react";
import { putApi } from "../../../Services/apiService";
import { toast } from "react-toastify";
import { getFamilyTreeIdFromStorage } from "../../../Utils/headOfLineRole";

const ConfirmRecievedInvitationModal = ({ onClose, invitation }) => {
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (invitation) {
      console.log("Confirm Modal - Invitation object:", invitation);
      console.log("Confirm Modal - Available fields:", Object.keys(invitation));
      console.log("Confirm Modal - event_id:", invitation.event_id);
      console.log("Confirm Modal - id:", invitation.id);
    }
  }, [invitation]);

  const handleChange = (event) => {
    setNote(event.target.value);
  };

  const handleConfirm = async () => {
    // Check multiple possible field names for event ID
    const eventId = invitation?.event_id || invitation?.id || invitation?.eventId;
    
    if (!eventId) {
      console.error("Invitation object:", invitation);
      console.error("Available fields:", Object.keys(invitation || {}));
      toast.error("Event ID is missing. Please check console for details.");
      return;
    }

    setLoading(true);
    try {
      const family_tree_id = getFamilyTreeIdFromStorage();
      console.log("Calling API with event ID:", eventId);
      const response = await putApi(
        `/accept-reject-event/${eventId}?family_tree_id=${family_tree_id}`,
        {
          invitation_status: 1,
          note: note || "",
        }
      );

      console.log("API Response:", response);

      if (response?.statusCode === 200) {
        toast.success(response?.message || "Invitation accepted successfully");
        onClose(true);
      } else {
        toast.error(response?.message || "Failed to accept invitation");
      }
    } catch (error) {
      console.error("Error accepting invitation:", error);
      console.error("Error response:", error?.response);
      const errorMessage = error?.response?.data?.message || error?.message || "Failed to accept invitation";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      
      <div className="common-modal">
        <div className="modal-header">
          <div className="modal-img"><span> <img src={window.getPublicUrl("/assets/images/confirm-icon.svg")} /></span></div>
        <button onClick={onClose} className="close">  <img src={window.getPublicUrl("/assets/images/close.svg")} /></button>
        <h2 className="header-titile mt-3">Confirm Attendance</h2>
        </div>
        <div className="modal-body">
          <label className="d-block">You are accepting this invitation. Would you like to add a note for the host?</label>
          <input
            type="text"
            name="note"
            id="note"
            onChange={handleChange}
            value={note}
            placeholder="Example: I'll bring snacks"
            className="w-100"
          />
        </div>
      </div>

      {/* =========== Buttons ========== */}
      <div className="modal-button">
        <button onClick={() => onClose(true)} className="btn btn-cancel" disabled={loading}>Cancel</button>
        <button onClick={handleConfirm} className="btn btn-confirm" disabled={loading}>
          {loading ? "Confirming..." : "Confirm"}
        </button>
      </div>
    </>
  );
};

export default ConfirmRecievedInvitationModal;
